module.exports = __webpack_public_path__ + "img/share-gray.8d01fd78.svg";